<template>
    <div>
        <reports-base
            reportsName="myShop"
            reportsTitle="Raport/ Mój Sklep"
            componentName="MyShop"
            :resultsPhrase="resultsPhrase"
        >
        </reports-base>
    </div>
</template>

<script>
import ReportsBase from '@/components/reports/ReportsBase'

export default {
    name: 'MyShop',
    components: {
        ReportsBase
    },
    computed: {
        resultsPhrase() {
            const isMyShop = !!this.$store.getters.getMyShop
            const isShopSelected = !!this.$store.getters.getMyShopQueryParams
                .merchant_id
            return !isShopSelected && !isMyShop
                ? 'Wybierz sklep w filtrze, aby wyświetlić raport'
                : undefined
        }
    },
    created() {
        if (!this.$store.getters.getMyShopLocationsByAvailableNetworks.length) {
            this.$router.push({ name: 'permission-denied' })
        }
        this.$store.dispatch('setMyShopDefaultMerchant')
    }
}
</script>
